<div>
  <dialog ref="dialog"
          v-if="step == 'name'"
          class="email-page">
    <p>
      Welcome to the Wizard Zines feedback site! Please type in your name (or
      handle!)
      so that we know who the feedback is from.
    </p>
    <form id="name-email" @submit.prevent="save_name_email">
      <label for="name">Name:</label><input id="name" ref="name">
      <button>Continue</button>
    </form>
  </dialog>

  <div class="user-feedback-page">
    <Annotator :document="document"
               :feedbacks="feedbacks"
               :person_id="person_id"
               v-if="document && person_id"
               v-model:active_feedback="active_feedback"
               v-model:hover_feedback="hover_feedback">
    </Annotator>
    <div style="position: relative;">
      <section class="comments" v-if="firstSyncDone">
        <h2> Your comments </h2>
        <Modal v-if="active_feedback && !active_feedback.id"
               @modal-close="close"
               @modal-submit="submit"
               :modal_error="modal_error"
               :saving="modal_saving"
               :feedback="active_feedback"> </Modal>

        <p v-if="feedbacks.length == 0 && !active_feedback"
           style="background: #ffdd9c">
          Highlight some text to leave feedback!
        </p>
        <template v-for="feedback_item in feedbacks">
          <!-- there are two of these Modals here and
               rn we need to careful to edit both if one
               changes, maybe refactor later -->
          <Modal v-if="active_feedback && active_feedback.id == feedback_item.id"
                 @modal-close="close"
                 @modal-submit="submit"
                 :modal_error="modal_error"
                 :saving="modal_saving"
                 :feedback="active_feedback"> </Modal>

          <article v-else
                   role="button"
                   aria-label="Edit feedback"
                   class="feedback-item"
                   :class="{
                      'active': active_feedback,
                   }"
                   @mouseenter="hover_feedback = feedback_item"
                   @mouseleave="hover_feedback = undefined"
                   @click="active_feedback = feedback_item">

            <span role="img" v-html="icons[feedback_item.emoji].emoji"> </span>
            {{feedback_item.content}}
          </article>
        </template>
      </section>
    </div>
  </div>
</div>
